import { Component, EventEmitter, OnInit, Input, Output, SimpleChanges, DestroyRef, inject } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { QuickInsightsService } from 'src/app/shared/services/quick-insights/quick-insights.service';
import { RatersService } from 'src/app/shared/services/raters/raters.service';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgIf, NgFor, NgStyle, DecimalPipe } from '@angular/common';
import { LtmsLoaderComponent } from '../../../../shared/components/ltms-loader/ltms-loader.component';
import { LtmsErrorComponent } from '../../../../shared/components/ltms-error/ltms-error.component';

@Component({
    selector: 'app-project-score-quick-insights-performers',
    templateUrl: './project-score-quick-insights-performers.component.html',
    styleUrls: ['./project-score-quick-insights-performers.component.scss'],
    imports: [NgIf, NgFor, NgStyle, LtmsLoaderComponent, LtmsErrorComponent, DecimalPipe]
})
export class ProjectScoreQuickInsightsPerformersComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  @Input('levelChanged') levelChanged!: Subject<any>;
  @Input() public showComparisonFlag;
  @Input() public sortOrderType;
  @Input() public selectedLevel: any = {};
  @Input() activeTab = '';
  @Output() exportTopPerformerDataToCSVDownload = new EventEmitter();
  @Output() exportBottomPerformerDataToCSVDownload = new EventEmitter();

  isLoading: boolean = false;
  isLoadingTopPerformer: boolean = true;
  isLoadingBottomPerformer: boolean = true;
  hierarchyStack: any = [];  

  sortTopOrder = 'desc';
  sortBottomOrder = 'asc';
  showAnalyticsDateFilter: boolean = true;

  topPerformers: any = [];
  bottomPerformers: any = [];
  errorCode: string = '404';
  numberOfPerformers: any = 3;
  totalResponses = 0;
  preventAPICall: boolean = false;

  hierarchyLevel: any = {};
  dateType = '';
  dateTypeChanged: boolean = false;
  accessChanged: boolean = false;
  hierarchyStackData: any = [];

  constructor(
    private _quickInsights: QuickInsightsService,
    private _raters: RatersService,
    private _helpers: HelpersService
  ) {}

  ngOnChanges(changes: SimpleChanges):void {
    this.levelChanged.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(obj => {
      this.dateTypeChanged = false; // making false to remove retained hierarchy level data
    });
    if(!this.dateTypeChanged && changes['selectedLevel']) {
      this.hierarchyLevel = {};
      this.hierarchyLevel = changes['selectedLevel'].currentValue;
      this.doEmpty()
      this.getTopPerformanceData();
      this.getBottomPerformanceData();
    }
  }
  
  ngOnInit() {
      this._helpers.appState.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response:any) => {
        if(response && !response.pending) {
          // Check if date changed
          this.dateTypeChanged = false;
          this.accessChanged = false;
          if(!_.isEmpty(this.dateType)) {
            if(this.dateType !== response.datePicker.trendType) {
              this.dateType = response.datePicker.trendType;
              this.dateTypeChanged = true;
              this.doEmpty()
              this.getTopPerformanceData();
              this.getBottomPerformanceData();
            }
          }else {
            this.dateType = response.datePicker.trendType;
          }
        }
      });
  }

  // Empty array data
  doEmpty() {
    this.bottomPerformers = [];
    this.topPerformers = [];
  }
  // Get top 3 performance
  getTopPerformanceData() {
    this.getPerformanceData(this.sortTopOrder);
  }
  // Get bottom 3 performance
  getBottomPerformanceData() {
    this.getPerformanceData(this.sortBottomOrder);
  }
  getPerformanceData(sortOrder) {
    this.isLoading = true;
    let params = {
      "brand_id": _.get(Helpers, "brandDetails._id"),
      "main_rater_type": _.get(Helpers, "brandDetails.main_rater_type"),
      "from": _.get(Helpers, "datePicker.startDate"),
      "to": _.get(Helpers, "datePicker.endDate"),
      // "is_custom_date_range_selected": _.get(Helpers, "isCustomDateRangeSelected"),
      "is_custom_date_range_selected": false,
      "sort_order": sortOrder,
      "sort_by":"net_promoter_score",
      "field_type":"hierarchy",
      "size":100
    }
    if(this.hierarchyLevel && this.hierarchyLevel.value) {
      params['target_hierarchy_level'] = this.hierarchyLevel.value;
    }
    if (this.hierarchyLevel && this.hierarchyLevel.category) {
      params['target_hierarchy_type'] = this.hierarchyLevel.category.toLowerCase();
    }
    var access = Helpers.getHierarchyStack();
    if (access && access.length && access[0].group_key[0]) {
      params['hierarchy_level'] = access[0].field_id;
      params['hierarchy_value'] = access[0].group_key[0];
    }else {
      this.isLoading = false;
      return;
    }
    this._quickInsights.getLeaderboardSummary(params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
      if (response && response.code == 0 && response.data) {
        response = response.data;
        this.getLeaderBoardSummaryData(response, params, sortOrder)
      }else{
        this.isLoading = false;
        // #todo
      }
    })
  }
  getLeaderBoardSummaryData(response, params, sortOrder) {
    if(sortOrder == 'desc') {
      var resp: any = [];
      this.topPerformers = [];
      _.each(response.summary, (res, idx) => {
        if (!(res.current && (Object.keys(res.current)).length)) {
          res = this.getDefaultResponse();
        } else {
            var previous = res.previous;
            res = res.current;
            res.previous = previous;
        }
        if (!(res.previous && (Object.keys(res.previous)).length)) {
          res.previous = this.getDefaultResponse();
        }
        res.name = idx;
        resp.push(res);
      });
      resp = _.sortBy(resp, 'net_promoter_score');
      if (sortOrder == 'desc') {
          resp = resp.reverse();
      }
      resp = resp.splice(0, this.numberOfPerformers);
      for (var idx in resp) {
        var performer = this.prepareDataForWidget(resp[idx]);
        performer = this.prepareDistributionPercentage(performer);
        this.topPerformers.push(performer);
      }
      var exportedData = this._quickInsights.getExportedData(resp, params.main_rater_type);
      if (exportedData && exportedData.columns) {
          exportedData.columns[0].display_name = sortOrder == 'desc' ? "Top Performers" : "Bottom Performers";
      }
    }
    if(sortOrder == 'asc') {
      var resp: any = [];
      // this.performers = [];
      this.bottomPerformers = [];
      _.each(response.summary, (res, idx) => {
        if (!(res.current && (Object.keys(res.current)).length)) {
          res = this.getDefaultResponse();
        } else {
            var previous = res.previous;
            res = res.current;
            res.previous = previous;
        }
        if (!(res.previous && (Object.keys(res.previous)).length)) {
          res.previous = this.getDefaultResponse();
        }
        res.name = idx;
        resp.push(res);
      });
      resp = _.sortBy(resp, 'net_promoter_score');
      if (sortOrder == 'desc') {
          resp = resp.reverse();
      }
      resp = resp.splice(0, this.numberOfPerformers);
      for (var idx in resp) {
        var performer = this.prepareDataForWidget(resp[idx]);
        performer = this.prepareDistributionPercentage(performer);
        this.bottomPerformers.push(performer);
      }
      var exportedData = this._quickInsights.getExportedData(resp, params.main_rater_type);
      if (exportedData && exportedData.columns) {
          exportedData.columns[0].display_name = sortOrder == 'desc' ? "Top Performers" : "Bottom Performers";
      }
    }
    this.exportTopPerformerDataToCSVDownload.emit(this.topPerformers);
    this.exportBottomPerformerDataToCSVDownload.emit(this.bottomPerformers);
    this.isLoading = false;
  }
  prepareDataForWidget(response) {
    var widgetData: any = {comparisons: []};
    var mainRaterType = Helpers.getBrandDetails().main_rater_type;
    var raterDetails = this._raters.getRaterDetails(mainRaterType);
    var quartile = {
      "title": "Quartile",
      "value": response?.quartile,
      "key": "quartile",
    }
    var name = {
        "value": response.name,
        "val_type": "text"
    }
    var score: any = {
      "title": mainRaterType == 3 ? Helpers.getDisplayLabel('NPS') : Helpers.getDisplayLabel('Rating'),
      "value": mainRaterType == 3 ? parseInt((response.net_promoter_score).toFixed(0)): parseInt((response.average_rating).toFixed(1)),
      "preValue": mainRaterType == 3 ? parseInt((response.previous.net_promoter_score).toFixed(0)): parseInt((response.previous.average_rating).toFixed(1)),
    }
    score.deviation = Helpers.getFieldDeviation(score.value, score.preValue);
    var responses: any = {
        "title": "Responses",
        "value": response.number_of_users_rated_primary_rating,
        "preValue": response.previous.number_of_users_rated_primary_rating,
    }
    responses.deviation = Helpers.getFieldDeviation(responses.value, responses.preValue);

    if (responses.value == 0) {
        score.value = 'N/A';
        score.val_type = "text";
    }
    widgetData.comparisons.push(name);
    widgetData.comparisons.push(quartile);
    widgetData.comparisons.push(score);
    widgetData.comparisons.push(responses);
    if (raterDetails && raterDetails.distributions) {
      this.totalResponses = 0;
        for(var idx in raterDetails.distributions) {
            raterDetails.distributions[idx].rated = response[raterDetails.distributions[idx].field_id];
            this.totalResponses += raterDetails.distributions[idx].rated;
        }
    }
    widgetData.distribution = raterDetails.distributions;
    widgetData.options = {
        "showComparison": true, // Need to change here
        "distributionType": "percentage"
    }
    return widgetData;
  }
  getDefaultResponse() {
    return {
      rank: 0,
      detractors: 0,
      quartile: null,
      promoters: 0,
      total_number_of_records: 0,
      passives: 0,
      negatives: 0,
      primary_rating_distribution: [],
      positives: 0,
      total_response: 0,
      net_promoter_score: 0,
      number_of_users_rated_primary_rating: 0,
      average_rating: 0
    }
  }
  getPositiveValue(value) {
    if (value == 0 || value < 0) {
      return -(value);
    }
    return value;
  }
  prepareDistributionPercentage(widgetData) {
    if (widgetData.options && widgetData.options.distributionType == 'percentage') {
      widgetData.distribution.forEach(singleRating => {
        let percentage = (singleRating.rated / this.totalResponses) * 100;
        singleRating['percentage'] = percentage;
      });
    }
    return widgetData;
  }
  progressBarStyleObj(distributionData) {
    return {
      'background-color': distributionData.color,
      'width': distributionData.percentage + '%'
    }
  }
  numberFormatting(value) {
    return Helpers.INRCurrencyPipeFilter(value);
  }
}
